var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"width100"},[_c('div',{staticClass:"width100 flex"},_vm._l((_vm.source),function(item,index){return _c('div',{key:index,staticClass:"item",style:({
      padding: _vm.paddingStyle,
      borderBottom:
        _vm.active === index ? _vm.activeStyle : '2px solid transparent',
      color: _vm.active === index ? _vm.activeColor : '#515a6e'
    }),on:{"click":function($event){return _vm.onClick(index)}}},[_vm._v("\n            "+_vm._s(item.label)+"\n        ")])}),0),_vm._v(" "),(_vm.animated)?[_c('transition',{attrs:{"name":"slide-fade"}},[_c(_vm.source[_vm.active].components,{tag:"component"})],1)]:[_c(_vm.source[_vm.active].components,{tag:"component"})]],2)}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./goingsrc/vueCom/layoutVue/go-components-tabs.vue